// Choix du thème s'il y en a plusieurs de définis
export const SET_THEME = "SET_THEME";
